import React from "react";
import { Flags } from "../../assets/flags";

interface FlagProps {
  className?: string;
  size?: number;
}

export const USFlagIcon: React.FC<FlagProps> = ({ className, size = 16 }) => {
  // Modify SVG to have 100% width and height with proper aspect ratio
  const svgContent = Flags.US.replace(
    '<svg',
    '<svg style="width: 100%; height: 100%;" preserveAspectRatio="xMidYMid slice"'
  );
  
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        borderRadius: "50%"
      }}
      dangerouslySetInnerHTML={{ __html: svgContent }}
      aria-label="US Flag"
    />
  );
};

export const MXFlagIcon: React.FC<FlagProps> = ({ className, size = 16 }) => {
  // Modify SVG to have 100% width and height with proper aspect ratio
  const svgContent = Flags.MX.replace(
    '<svg',
    '<svg style="width: 100%; height: 100%;" preserveAspectRatio="xMidYMid slice"'
  );
  
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        borderRadius: "50%"
      }}
      dangerouslySetInnerHTML={{ __html: svgContent }}
      aria-label="Mexico Flag"
    />
  );
};

export const getFlagIcon = (
  locale: string,
  size: number = 16
): React.ReactNode => {
  const normalizedLocale = (locale || "").toLowerCase();

  if (normalizedLocale === "en") {
    return <USFlagIcon size={size} />;
  } else if (normalizedLocale === "es") {
    return <MXFlagIcon size={size} />;
  }

  return <USFlagIcon size={size} />;
};
